// extracted by mini-css-extract-plugin
export var deleteModal = "_g2-0";